// StopLineePanel.jsx — gestione stop personalizzato per singola linea
import React, { useState, useEffect } from "react";
import { fetchJson } from "../../api";

const GOLD = "#d4a550";
const BG = "#0f0f17";
const BORDER = "rgba(255,255,255,0.08)";
const TEXT = "#e8e6df";
const TEXT_DIM = "rgba(232,230,223,0.45)";

export default function StopLineePanel({ planId, lanes, onClose, onSaved }) {
  const [stopDates, setStopDates] = useState({});
  const [globalFrom, setGlobalFrom] = useState("");
  const [globalTo, setGlobalTo] = useState("");
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    const init = {};
    lanes.forEach(l => {
      init[l.lineId] = {
        from: l.customStopFrom || "",
        to: l.customStopTo || "",
        label: l.lineLabel || `L${l.lineNo}`,
        phaseName: l.phaseName,
      };
    });
    setStopDates(init);
  }, [lanes]);

  const applyToAll = () => {
    if (!globalFrom && !globalTo) return;
    setStopDates(prev => {
      const next = { ...prev };
      Object.keys(next).forEach(id => {
        next[id] = { ...next[id], from: globalFrom, to: globalTo };
      });
      return next;
    });
  };

  const handleSave = async () => {
    setSaving(true);
    setMsg(null);
    try {
      for (const [lineId, val] of Object.entries(stopDates)) {
        await fetchJson(`/postplans/${planId}/lane-stop`, {
          method: "POST",
          body: JSON.stringify({
            lineId: Number(lineId),
            customStopFrom: val.from || null,
            customStopTo: val.to || null,
          }),
        });
      }
      setMsg("Salvato");
      setTimeout(() => { onSaved(); }, 800);
    } catch (e) {
      setMsg("Errore: " + e.message);
    } finally {
      setSaving(false);
    }
  };

  const byPhase = {};
  Object.entries(stopDates).forEach(([id, val]) => {
    if (!byPhase[val.phaseName]) byPhase[val.phaseName] = [];
    byPhase[val.phaseName].push({ id, ...val });
  });

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:300,display:"flex",alignItems:"center",justifyContent:"center" }} onClick={onClose}>
      <div style={{ background:BG,border:"1px solid rgba(212,165,80,0.3)",borderRadius:14,padding:"24px 28px",width:580,maxHeight:"80vh",display:"flex",flexDirection:"column",gap:16 }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between" }}>
          <div style={{ fontWeight:700,fontSize:15,color:GOLD }}>Stop per linea</div>
          <button onClick={onClose} style={{ background:"none",border:"none",color:TEXT_DIM,cursor:"pointer",fontSize:18 }}>x</button>
        </div>
        <div style={{ background:"rgba(212,165,80,0.05)",border:"1px solid rgba(212,165,80,0.2)",borderRadius:8,padding:"12px 14px",display:"flex",gap:12,alignItems:"flex-end",flexWrap:"wrap" }}>
          <div>
            <div style={{ fontSize:10,color:TEXT_DIM,marginBottom:4 }}>Dal</div>
            <input type="date" value={globalFrom} onChange={e=>setGlobalFrom(e.target.value)} style={{ background:"transparent",border:"1px solid rgba(255,255,255,0.08)",borderRadius:6,color:TEXT,fontSize:13,padding:"5px 8px",colorScheme:"dark" }} />
          </div>
          <div>
            <div style={{ fontSize:10,color:TEXT_DIM,marginBottom:4 }}>Al</div>
            <input type="date" value={globalTo} onChange={e=>setGlobalTo(e.target.value)} style={{ background:"transparent",border:"1px solid rgba(255,255,255,0.08)",borderRadius:6,color:TEXT,fontSize:13,padding:"5px 8px",colorScheme:"dark" }} />
          </div>
          <button onClick={applyToAll} style={{ background:"rgba(212,165,80,0.12)",border:"1px solid rgba(212,165,80,0.35)",borderRadius:6,color:GOLD,cursor:"pointer",padding:"6px 14px",fontSize:12,fontWeight:700 }}>Applica a tutte</button>
          <button onClick={()=>setStopDates(prev=>{const next={...prev};Object.keys(next).forEach(id=>{next[id]={...next[id],from:"",to:""};});return next;})} style={{ background:"none",border:"1px solid rgba(248,113,113,0.3)",borderRadius:6,color:"rgba(248,113,113,0.6)",cursor:"pointer",padding:"6px 12px",fontSize:12 }}>Rimuovi tutti</button>
        </div>
        <div style={{ overflowY:"auto",flex:1,scrollbarWidth:"thin",scrollbarColor:"rgba(212,165,80,0.4) transparent" }}>
          {Object.entries(byPhase).map(([phase, lines]) => (
            <div key={phase} style={{ marginBottom:12 }}>
              <div style={{ fontSize:10,fontWeight:700,color:GOLD,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:6,paddingBottom:4,borderBottom:"1px solid rgba(255,255,255,0.08)" }}>{phase}</div>
              {lines.map(line => (
                <div key={line.id} style={{ display:"flex",alignItems:"center",gap:12,padding:"6px 0",borderBottom:"1px solid rgba(255,255,255,0.04)" }}>
                  <div style={{ fontSize:12,color:TEXT,minWidth:130,fontWeight:500 }}>{line.label}</div>
                  <input type="date" value={line.from} onChange={e=>setStopDates(prev=>({...prev,[line.id]:{...prev[line.id],from:e.target.value}}))} style={{ background:"transparent",border:line.from?"1px solid rgba(248,113,113,0.4)":"1px solid rgba(255,255,255,0.08)",borderRadius:4,color:TEXT,fontSize:12,padding:"4px 6px",colorScheme:"dark",width:130 }} />
                  <span style={{ color:TEXT_DIM,fontSize:11 }}>-</span>
                  <input type="date" value={line.to} onChange={e=>setStopDates(prev=>({...prev,[line.id]:{...prev[line.id],to:e.target.value}}))} style={{ background:"transparent",border:line.to?"1px solid rgba(248,113,113,0.4)":"1px solid rgba(255,255,255,0.08)",borderRadius:4,color:TEXT,fontSize:12,padding:"4px 6px",colorScheme:"dark",width:130 }} />
                  {(line.from||line.to) && <button onClick={()=>setStopDates(prev=>({...prev,[line.id]:{...prev[line.id],from:"",to:""}}))} style={{ background:"none",border:"none",color:"rgba(248,113,113,0.5)",cursor:"pointer",fontSize:16 }}>x</button>}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",borderTop:"1px solid rgba(255,255,255,0.08)",paddingTop:12 }}>
          <span style={{ fontSize:12,color:msg==="Salvato"?"#4ade80":"#f87171" }}>{msg||""}</span>
          <div style={{ display:"flex",gap:10 }}>
            <button onClick={onClose} style={{ background:"none",border:"1px solid rgba(255,255,255,0.08)",borderRadius:6,color:TEXT_DIM,cursor:"pointer",padding:"7px 16px",fontSize:13 }}>Annulla</button>
            <button onClick={handleSave} disabled={saving} style={{ background:"rgba(212,165,80,0.15)",border:"1px solid rgba(212,165,80,0.4)",borderRadius:6,color:GOLD,cursor:"pointer",padding:"7px 16px",fontSize:13,fontWeight:700 }}>{saving?"Salvataggio...":"Salva"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}